// component designed to show last punch details like clock in / out with timestamp
// input : Last Punch Object
import React from "react";
import PropTypes from "prop-types";
import { Typography, makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import moment from "moment";
import {
  dateConfig,
  timeConfig,
  CLOCK_IN,
  CLOCK_OUT,
  TRANSFER,
  SET_EMPTY,
} from "../config";

const useStyles = makeStyles(() => ({
  loginStatus: {
    marginRight: 24,
    marginTop: 10,
    textAlignLast: "right",
  },
  clockIn: {
    fontSize: 14,
    textTransform: "uppercase",
    color: "#8DC13F",
    fontWeight: "bolder",
    paddingTop: 5,
  },
  clockOut: {
    fontSize: 14,
    textTransform: "uppercase",
    color: "#58595B",
    fontWeight: "bolder",
    paddingTop: 5,
  },
  time: {
    fontSize: 10,
    textTransform: "uppercase",
    color: "#58595B",
  },
}));

export const LastPunchStatus = (props) => {
  const { t } = useTranslation();
  const { lastPunch } = props;
  const classes = useStyles();
  let lastPunchTime = SET_EMPTY;
  let lastPunchStatus = SET_EMPTY;
  let showIn = false;
  let showOut = false;

  if (lastPunch) {
    if (
      lastPunch.activityName === CLOCK_IN ||
      lastPunch.activityName === TRANSFER
    ) {
      showIn = true;
      let ts = lastPunch.inLocalTS;
      if (ts === SET_EMPTY || ts === undefined) {
        ts = lastPunch.activityTS;
      }

      lastPunchTime =
        moment(ts).format(dateConfig.format2) +
        " " +
        moment(ts).format(timeConfig.format3);

      lastPunchStatus = t("pgPunch.lblClockedIn");
      lastPunchTime = t("pgPunch.lblIn") + " " + lastPunchTime;
    } else if (lastPunch && lastPunch.activityName === CLOCK_OUT) {
      showOut = true;
      let ts = lastPunch.outLocalTS;
      if (ts === SET_EMPTY || ts === undefined) {
        ts = lastPunch.activityTS;
      }
      lastPunchTime =
        moment(ts).format(dateConfig.format2) +
        " " +
        moment(ts).format(timeConfig.format3);

      lastPunchStatus = t("pgPunch.lblClockedOut");
      lastPunchTime = t("pgPunch.lblOut") + " " + lastPunchTime;
    }
  }

  return (
    <div>
      <section className={classes.loginStatus}>
        {showIn && (
          <Typography className={classes.clockIn}>{lastPunchStatus}</Typography>
        )}

        {showOut && (
          <Typography className={classes.clockOut}>
            {lastPunchStatus}
          </Typography>
        )}

        <Typography className={classes.time}>{lastPunchTime}</Typography>
      </section>
    </div>
  );
};

LastPunchStatus.propTypes = {
  lastPunch: PropTypes.object.isRequired,
};

export default LastPunchStatus;
